import { useState, useEffect } from "react";
import SignUp from "./SignUp";

const Register = ({ webConfig }) => {
  const [step, setStep] = useState({});
  useEffect(() => {
    setStep({
      name: "signUp",
      component: <SignUp webConfig={webConfig} setStep={setStep} />,
    });
  }, []);
  return <>{step?.component}</>;
};
export default Register;
